import classNames from "classnames";
import styles from "./styles.module.scss";
import { Icons } from "assets";

interface CustomRadioButtonProps extends React.HTMLProps<HTMLDivElement> {
  active: boolean;
}

const CustomRadioButton = ({
  active,
  onClick,
  className,
}: CustomRadioButtonProps) => {
  return (
    <div
      className={classNames(
        styles.mainContainer,
        active && styles.active,
        className
      )}
      onClick={onClick}
    >
      {active ? <Icons.Tick /> : null}
    </div>
  );
};

export default CustomRadioButton;
